import OnvoBase, { JobUpdateEvent } from "../base.js";
import { Dashboard, DashboardMeta, DataSource } from "../types/index.js";

export class OnvoDatasource extends OnvoBase {
  #id: string;

  constructor(id: string, apiKey: string, options?: { endpoint: string }) {
    super(apiKey, options);
    this.#id = id;
  }

  /**
   * Initializes the data source.
   * @returns {Promise<{ success: boolean }>} A promise that resolves to an object with a success property.
   */
  initialize(callback?: (event: JobUpdateEvent) => void): Promise<{ success: boolean }> {
    return this._fetchStreamBase(
      "/api/datasources/" + this.#id + "/initialize",
      "GET",
      undefined,
      callback
    ) as Promise<{ success: boolean }>;
  }

  /**
   * Uploads a file to the data source.
   * @param {File} file - The file to upload.
   * @returns {Promise<DataSource>} A promise that resolves to the data source object.
   */
  uploadFile(file: File): Promise<DataSource> {
    const formData = new FormData();
    formData.set("file", file);
    return this._fetchBase(
      "/api/datasources/" + this.#id + "/upload-file",
      "POST",
      formData,
      true
    ) as Promise<DataSource>;
  }

  /**
   * Retrieves the sample data from the data source.
   * @returns {Promise<any[]>} A promise that resolves to an array of sample data.
   */
  sample(): Promise<any[]> {
    return this._fetchBase(
      "/api/datasources/" + this.#id + "/sample"
    ) as Promise<any[]>;
  }

  /**
 * Retrieves the export data from the data source.
 * @returns {Promise<{url:string}>} A promise that resolves to an object with a url property.
 */
  export(callback?: (event: JobUpdateEvent) => void): Promise<{ url: string }> {
    return this._fetchStreamBase(
      "/api/datasources/" + this.#id + "/export",
      "GET",
      undefined,
      callback
    ) as Promise<{ url: string }>;

  }

  /**
* Retrieves the dashboards connected to the data source.
* @returns {Promise<(Dashboard & { _meta: DashboardMeta })[]>} A promise that resolves to an array of dashboards.
*/
  dashboards(): Promise<(Dashboard & { _meta: DashboardMeta })[]> {
    return this._fetchBase(
      "/api/datasources/" + this.#id + "/dashboards"
    ) as Promise<
      (Dashboard & { _meta: DashboardMeta })[]
    >;
  }
}
